import { FeesRepo } from "./fees.repo";
import * as _ from "lodash";
import * as moment from "moment";
import * as echarts from "echarts";
import { exportToCSV } from "../common/utils/exportToCSV";

class FeesController implements angular.IOnInit {
  public isLoading: boolean = false;
  public clientSummaryItems: Array<any>;

  // currency list
  public currencyList = ["MUR", "EUR", "GBP", "USD", "CHF"];
  public selectedCurrency;

  // filters
  public searchFilterList;
  public fromDate;
  public toDate;
  public currentDate;
  public lastMonth;

  public totalCombinedFeeValue;
  public totalMCBFeeValue;
  public totalEDRFeeValue;

  public totalCombinedNav;
  public totalMCBNav;
  public totalEDRNav;

  public feesByCustodian;

  // Monthly Nav and Fees Chart options
  public feesNAVByMonthLineChart;
  public feesNAVByMonthLineChartOptions;

  public feeValueByMonthChart;
  public feeValueByMonthChartOptions;

  public mcbColour = "#00475a";
  public edrColour = "#91c840";

  // monthly NAVs and Fees Grid
  public monthlyFeesGridOptions;

  // Top/Bottom Portfolio Fees
  public feesByPortfolioLimit = 10;
  public topPortfolioFeeChart;
  public topPortfolioFeeChartOptions;
  public isLoadingPortfolioFees = false;

  public topPortfolioFees;
  public bottomPortfolioFees;
  public portfolioFeeDate;

  public bottomPortfolioFeeChart;
  public bottomPortfolioFeeChartOptions;

  public topPortfolioFeesGridOptions;
  public bottomPortfolioFeesGridOptions;
  public sortTopBottomPortfolioFeesByNav: boolean = false;

  //card hide and shows
  public showMonthlyNavAndFees: boolean = true;
  public showPortfolioFee: boolean = true;
  public showClientFee: boolean = true;
  public showFeeTypesFee: boolean = true;

  // Top Bottom Client
  public feesByClientLimit = 10;
  public topClientFeeChart;
  public topClientFeeChartOptions;
  public isLoadingClientFees = false;

  public topClientFees;
  public bottomClientFees;
  public clientFeeDate;

  public bottomClientFeeChart;
  public bottomClientFeeChartOptions;

  public topClientFeesGridOptions;
  public bottomClientFeesGridOptions;
  public sortTopBottomClientFeesByNav: boolean = false;

  // Top Bottom Fee Types

  public feesByFeeTypesLimit = 10;
  public topFeeTypesFeeChart;
  public topFeeTypesFeeChartOptions;
  public isLoadingFeeTypesFees = false;

  public topFeeTypesFees;
  public bottomFeeTypesFees;
  public feeTypesFeeDate;

  public bottomFeeTypesFeeChart;
  public bottomFeeTypesFeeChartOptions;

  public topFeeTypesFeesGridOptions;
  public bottomFeeTypesFeesGridOptions;
  public sortTopBottomFeeTypesFeesByNav: boolean = false;

  // FeeCalculationType List
  public feeCalulationTypes = [
    {
      name: "Combined",
      value: FeeCalculationType.COMBINED,
    },
    {
      name: "MCB",
      value: FeeCalculationType.MCB,
    },
    {
      name: "EDR",
      value: FeeCalculationType.EDR,
    },
  ];

  public selectedFeeCalculationTypePortfolioFees = FeeCalculationType.COMBINED;
  public selectedFeeCalculationTypeClientFees = FeeCalculationType.COMBINED;
  public selectedFeeCalculationTypeFeeTypesFees = FeeCalculationType.COMBINED;

  /** @ngInject */
  constructor(
    private feesRepo: FeesRepo,
    private $window: angular.IWindowService,
    private notifyjs,
    private $scope: angular.IScope
  ) {
    this.currentDate = new Date();

    if (_.isEmpty(this.fromDate) || _.isEmpty(this.toDate)) {
      this.fromDate = new Date(
        moment(this.currentDate).subtract(6, "months").toString()
      ); //;
      this.toDate = moment(this.currentDate)
        .subtract(1, "months")
        .endOf("month")
        .format("YYYY-MM-DD");
    }
    this.portfolioFeeDate = moment(this.currentDate)
      .subtract(1, "months")
      .endOf("month")
      .format("YYYY-MM-DD");
    this.lastMonth = new Date(
      moment(this.currentDate)
        .subtract(1, "months")
        .endOf("month")
        .format("YYYY-MM-DD")
    );
    this.clientFeeDate = new Date(
      moment(this.currentDate)
        .subtract(1, "months")
        .endOf("month")
        .format("YYYY-MM-DD")
    );
    this.feeTypesFeeDate = new Date(
      moment(this.currentDate)
        .subtract(1, "months")
        .endOf("month")
        .format("YYYY-MM-DD")
    );

    // monthly nav and fees
    this.feesNAVByMonthLineChart = echarts.init(
      document.getElementById("month-fee-nav-chart")
    );
    this.$scope.$watch(
      () =>
        this.feesNAVByMonthLineChart.getDom().parentElement.parentElement
          .clientHeight,
      this.feesNAVByMonthLineChart.resize()
    );

    this.feeValueByMonthChart = echarts.init(
      document.getElementById("month-fee-value-chart")
    );
    this.$scope.$watch(
      () =>
        this.feeValueByMonthChart.getDom().parentElement.parentElement
          .clientHeight,
      this.feeValueByMonthChart.resize()
    );

    this.topPortfolioFeeChart = echarts.init(
      document.getElementById("top-portfolio-fee-value-chart")
    );
    this.$scope.$watch(
      () =>
        this.topPortfolioFeeChart.getDom().parentElement.parentElement
          .clientHeight,
      this.topPortfolioFeeChart.resize()
    );

    this.bottomPortfolioFeeChart = echarts.init(
      document.getElementById("bottom-portfolio-fee-value-chart")
    );
    this.$scope.$watch(
      () =>
        this.bottomPortfolioFeeChart.getDom().parentElement.parentElement
          .clientHeight,
      this.bottomPortfolioFeeChart.resize()
    );

    this.topClientFeeChart = echarts.init(
      document.getElementById("top-client-fee-value-chart")
    );
    this.$scope.$watch(
      () =>
        this.topClientFeeChart.getDom().parentElement.parentElement
          .clientHeight,
      this.topClientFeeChart.resize()
    );

    this.bottomClientFeeChart = echarts.init(
      document.getElementById("bottom-client-fee-value-chart")
    );
    this.$scope.$watch(
      () =>
        this.bottomClientFeeChart.getDom().parentElement.parentElement
          .clientHeight,
      this.bottomClientFeeChart.resize()
    );

    this.topFeeTypesFeeChart = echarts.init(
      document.getElementById("top-fee-types-fee-value-chart")
    );
    this.$scope.$watch(
      () =>
        this.topFeeTypesFeeChart.getDom().parentElement.parentElement
          .clientHeight,
      this.topFeeTypesFeeChart.resize()
    );

    // this.bottomFeeTypesFeeChart = echarts.init(document.getElementById('bottom-fee-types-fee-value-chart'));
    // this.$scope.$watch(() => this.bottomFeeTypesFeeChart.getDom().parentElement.parentElement.clientHeight, this.bottomFeeTypesFeeChart.resize())
  }

  $onInit() {
    this.selectedCurrency = "MUR";
    this.updateData();
    this.updatePortfolioFees();
    this.updateClientFees();
    this.updateFeeTypeFees();
    this.monthlyFeesGridOptions = this.$scope["monthlyFeesGridOptions"] = {
      data: [],
      urlSync: false,
    };

    this.topPortfolioFeesGridOptions = this.$scope[
      "topPortfolioFeesGridOptions"
    ] = {
      data: [],
      urlSync: false,
    };

    this.bottomPortfolioFeesGridOptions = this.$scope[
      "bottomPortfolioFeesGridOptions"
    ] = {
      data: [],
      urlSync: false,
    };

    this.topClientFeesGridOptions = this.$scope["topClientFeesGridOptions"] = {
      data: [],
      urlSync: false,
    };

    this.bottomClientFeesGridOptions = this.$scope[
      "bottomClientFeesGridOptions"
    ] = {
      data: [],
      urlSync: false,
    };

    this.topFeeTypesFeesGridOptions = this.$scope[
      "topFeeTypesFeesGridOptions"
    ] = {
      data: [],
      urlSync: false,
    };

    // this.bottomFeeTypesFeesGridOptions = this.$scope['bottomFeeTypesFeesGridOptions'] = {
    //   data: [],
    //   urlSync: false
    // };
  }

  updateData = () => {
    this.getManagementFeesByCustodian();
  };

  filterDateParameters = (filter) => {
    _.forEach(this.searchFilterList, (filterOption) => {
      if (filterOption.name !== filter.name) {
        filterOption.active = false;
      }
    });
    filter.active = true;
    this.fromDate = filter.fromDate;
    this.toDate = filter.toDate;
    this.updateData();
  };

  onSelectCurrencyClose() {
    this.updateData();
    this.updatePortfolioFees();
    this.updateClientFees();
    this.updateFeeTypeFees();
  }

  getPercentageFromDecimal = (value) => {
    return +(value * 100).toFixed(2);
  };

  formatDate(selectedDate) {
    return moment(selectedDate).endOf("month").format("YYYY-MM");
  }

  fromDateChanged = () => {
    if (this.fromDate < this.toDate) {
      this.updateData();
    }
  };

  toDateChanged = () => {
    this.updateData();
  };

  getAllManagementFeeClientSummary = () => {
    this.fromDate = moment("2019-01-31").format("YYYY-MM-DD");
    this.toDate = moment(this.currentDate)
      .subtract(1, "months")
      .endOf("month")
      .format("YYYY-MM-DD");
    this.updateData();
  };

  getManagementFeesByCustodian = () => {
    this.isLoading = true;
    let toDate = moment(this.toDate).endOf("month").format("YYYY-MM-DD");
    let fromDate = moment(this.fromDate).endOf("month").format("YYYY-MM-DD");
    this.feesRepo
      .getManagementFeesByCustodian(fromDate, toDate, this.selectedCurrency)
      .then((res) => {
        this.feesByCustodian = res.data as Array<any>;

        this.getMonthlyNavAndPortfolioGraph();

        this.getMonthlyFeeValueAndPortfolioGraph();

        this.monthlyFeesGridOptions.data = _.chain(this.feesByCustodian)
          .groupBy("feeDate")
          .map((feeParams, feeDate) => {
            return {
              feeDate: feeDate,
              currency: this.selectedCurrency,
              totalCombinedMarketValue: feeParams
                .filter(
                  (feeParam) =>
                    feeParam.calculationType == FeeCalculationType.COMBINED
                )
                .reduce((prev, next) => {
                  return prev + next.totalMarketValue;
                }, 0),
              totalCombinedFeeValue: feeParams
                .filter(
                  (feeParam) =>
                    feeParam.calculationType == FeeCalculationType.COMBINED
                )
                .reduce((prev, next) => {
                  return prev + next.totalFeeValue;
                }, 0),
              totalCombinedPortfolios: feeParams
                .filter(
                  (feeParam) =>
                    feeParam.calculationType == FeeCalculationType.COMBINED
                )
                .reduce((prev, next) => {
                  return prev + next.totalNumberOfPortfolios;
                }, 0),
              totalMCBMarketValue: feeParams
                .filter(
                  (feeParam) =>
                    feeParam.calculationType == FeeCalculationType.MCB
                )
                .reduce((prev, next) => {
                  return prev + next.totalMarketValue;
                }, 0),
              totalMCBFeeValue: feeParams
                .filter(
                  (feeParam) =>
                    feeParam.calculationType == FeeCalculationType.MCB
                )
                .reduce((prev, next) => {
                  return prev + next.totalFeeValue;
                }, 0),
              totalMCBPortfolios: feeParams
                .filter(
                  (feeParam) =>
                    feeParam.calculationType == FeeCalculationType.MCB
                )
                .reduce((prev, next) => {
                  return prev + next.totalNumberOfPortfolios;
                }, 0),
              totalEDRMarketValue: feeParams
                .filter(
                  (feeParam) =>
                    feeParam.calculationType == FeeCalculationType.EDR
                )
                .reduce((prev, next) => {
                  return prev + next.totalMarketValue;
                }, 0),
              totalEDRFeeValue: feeParams
                .filter(
                  (feeParam) =>
                    feeParam.calculationType == FeeCalculationType.EDR
                )
                .reduce((prev, next) => {
                  return prev + next.totalFeeValue;
                }, 0),
              totalEDRPortfolios: feeParams
                .filter(
                  (feeParam) =>
                    feeParam.calculationType == FeeCalculationType.EDR
                )
                .reduce((prev, next) => {
                  return prev + next.totalNumberOfPortfolios;
                }, 0),
            };
          })
          .sortBy("feeDate")
          .reverse()
          .value();
      })
      .catch((err) => {
        this.notifyjs("Failed to load fee values for custodians " + err.data);
      })
      .finally(() => {
        this.isLoading = false;
      });
  };

  exportMonthlyFeesToCSV = ($event: angular.IAngularEvent) => {
    $event.stopPropagation();
    exportToCSV(
      this.monthlyFeesGridOptions.grid.filtered,
      "Monthly NAVs and Fees",
      true
    );
  };

  normaliseNumbers = (labelValue) => {
    // Nine Zeroes for Billions
    return Math.abs(Number(labelValue)) >= 1.0e9
      ? Math.abs(Number(labelValue)) / 1.0e9 + "B"
      : // Six Zeroes for Millions
      Math.abs(Number(labelValue)) >= 1.0e6
      ? Math.abs(Number(labelValue)) / 1.0e6 + "M"
      : // Three Zeroes for Thousands
      Math.abs(Number(labelValue)) >= 1.0e3
      ? Math.abs(Number(labelValue)) / 1.0e3 + "K"
      : Math.abs(Number(labelValue));
  };

  getMonthlyNavAndPortfolioGraph = () => {
    let dateRanges = _.sortedUniq(
      this.feesByCustodian.map((fee) => fee.feeDate)
    );

    let mcbNavs = dateRanges
      .map((date) => {
        return this.feesByCustodian.filter((feeParam) => {
          return (
            feeParam.feeDate === date &&
            feeParam.calculationType == FeeCalculationType.MCB
          );
        })[0];
      })
      .map((feeParam) => {
        return +feeParam.totalMarketValue.toFixed(2);
      });

    let mcbPortfolios = dateRanges
      .map((date) => {
        return this.feesByCustodian.filter((feeParam) => {
          return (
            feeParam.feeDate === date &&
            feeParam.calculationType == FeeCalculationType.MCB
          );
        })[0];
      })
      .map((feeParam) => {
        return feeParam.totalNumberOfPortfolios;
      });

    let edrNavs = dateRanges
      .map((date) => {
        return this.feesByCustodian.filter((feeParam) => {
          return (
            feeParam.feeDate === date &&
            feeParam.calculationType == FeeCalculationType.EDR
          );
        })[0];
      })
      .map((feeParam) => {
        return +feeParam.totalMarketValue.toFixed(2);
      });

    let edrPortfolios = dateRanges
      .map((date) => {
        return this.feesByCustodian.filter((feeParam) => {
          return (
            feeParam.feeDate === date &&
            feeParam.calculationType == FeeCalculationType.EDR
          );
        })[0];
      })
      .map((feeParam) => {
        return feeParam.totalNumberOfPortfolios;
      });

    this.feesNAVByMonthLineChartOptions = {
      title: {
        text: `NAVs`,
        textStyle: {
          fontFamily: "Seravek",
        },
      },
      colors: ["red", "blue"],
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow",
        },
      },
      legend: {
        show: true,
        // bottom: 0,
        type: "scroll",
        orient: "horizontal",
      },
      grid: {
        left: "3%",
        right: "4%",
        bottom: "3%",
        containLabel: true,
      },
      toolbox: {
        feature: {
          saveAsImage: {
            title: "Save as Image",
          },
          dataZoom: {
            yAxisIndex: "none",
            title: {
              zoom: "Zoom In",
              back: "Back",
            },
          },
          restore: {
            title: "Restore",
          },
        },
      },
      xAxis: {
        type: "category",
        data: dateRanges,
        boundaryGap: true,
        axisLabel: {
          formatter: (params) => {
            return `${moment(params).format("MMM-YY")}`;
          },
        },
      },
      yAxis: [
        {
          type: "value",
          name: "NAVs",
          axisLabel: {
            formatter: (params) => {
              return params > 0
                ? `${this.selectedCurrency} ${this.normaliseNumbers(params)}`
                : "";
            },
          },
        },
        {
          type: "value",
          name: "Portfolios",
          position: "right",
        },
      ],
      series: [
        {
          type: "bar",
          name: "MCB NAV",
          stack: "NAV",

          data: mcbNavs,
          itemStyle: {
            color: this.mcbColour,
            fontFamily: "Helvetica",
          },
        },
        {
          type: "bar",
          name: "EDR NAV",
          stack: "NAV",
          data: edrNavs,
          itemStyle: {
            color: this.edrColour,
            fontFamily: "Helvetica",
          },
        },
        {
          name: "No. Of MCB Portfolios",
          type: "line",
          yAxisIndex: 1,
          data: mcbPortfolios,
          itemStyle: {
            color: this.mcbColour,
            fontFamily: "Helvetica",
          },
        },
        {
          name: "No. Of EDR Portfolios",
          type: "line",
          yAxisIndex: 1,
          data: edrPortfolios,
          itemStyle: {
            color: this.edrColour,
            fontFamily: "Helvetica",
          },
        },
      ],
    };

    this.feesNAVByMonthLineChart.setOption(this.feesNAVByMonthLineChartOptions);
  };

  getMonthlyFeeValueAndPortfolioGraph = () => {
    let dateRanges = _.sortedUniq(
      this.feesByCustodian.map((fee) => fee.feeDate)
    );

    let mcbFeeValues = dateRanges
      .map((date) => {
        return this.feesByCustodian.filter((feeParam) => {
          return (
            feeParam.feeDate === date &&
            feeParam.calculationType == FeeCalculationType.MCB
          );
        })[0];
      })
      .map((feeParam) => {
        return +feeParam.totalFeeValue.toFixed(2);
      });

    let mcbPortfolios = dateRanges
      .map((date) => {
        return this.feesByCustodian.filter((feeParam) => {
          return (
            feeParam.feeDate === date &&
            feeParam.calculationType == FeeCalculationType.MCB
          );
        })[0];
      })
      .map((feeParam) => {
        return feeParam.totalNumberOfPortfolios;
      });

    let edrFeeValues = dateRanges
      .map((date) => {
        return this.feesByCustodian.filter((feeParam) => {
          return (
            feeParam.feeDate === date &&
            feeParam.calculationType == FeeCalculationType.EDR
          );
        })[0];
      })
      .map((feeParam) => {
        return +feeParam.totalFeeValue.toFixed(2);
      });

    let edrPortfolios = dateRanges
      .map((date) => {
        return this.feesByCustodian.filter((feeParam) => {
          return (
            feeParam.feeDate === date &&
            feeParam.calculationType == FeeCalculationType.EDR
          );
        })[0];
      })
      .map((feeParam) => {
        return feeParam.totalNumberOfPortfolios;
      });

    this.feeValueByMonthChartOptions = {
      title: {
        text: `Fees`,
        textStyle: {
          fontFamily: "Seravek",
        },
      },
      colors: ["red", "blue"],
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow",
        },
      },
      legend: {
        show: true,
        type: "scroll",
        orient: "horizontal",
      },
      grid: {
        left: "3%",
        right: "4%",
        bottom: "3%",
        containLabel: true,
      },
      toolbox: {
        feature: {
          saveAsImage: {
            title: "Save as Image",
          },
          dataZoom: {
            yAxisIndex: "none",
            title: {
              zoom: "Zoom In",
              back: "Back",
            },
          },
          restore: {
            title: "Restore",
          },
        },
      },
      xAxis: {
        type: "category",
        data: dateRanges,
        boundaryGap: true,
        axisLabel: {
          formatter: (params) => {
            return `${moment(params).format("MMM-YY")}`;
          },
        },
      },
      yAxis: [
        {
          type: "value",
          name: "Fees",
          axisLabel: {
            formatter: (params) => {
              return params > 0
                ? `${this.selectedCurrency} ${this.normaliseNumbers(params)}`
                : "";
            },
          },
        },
        {
          type: "value",
          name: "Portfolios",
          position: "right",
        },
      ],
      series: [
        {
          type: "bar",
          name: "MCB Fees",
          stack: "FeeValue",

          data: mcbFeeValues,
          itemStyle: {
            color: this.mcbColour,
            fontFamily: "Helvetica",
          },
        },
        {
          type: "bar",
          name: "EDR Fees",
          stack: "FeeValue",
          data: edrFeeValues,
          itemStyle: {
            color: this.edrColour,
            fontFamily: "Helvetica",
          },
        },
        {
          name: "No. Of MCB Portfolios",
          type: "line",
          yAxisIndex: 1,
          data: mcbPortfolios,
          itemStyle: {
            color: this.mcbColour,
            fontFamily: "Helvetica",
          },
        },
        {
          name: "No. Of EDR Portfolios",
          type: "line",
          yAxisIndex: 1,
          data: edrPortfolios,
          itemStyle: {
            color: this.edrColour,
            fontFamily: "Helvetica",
          },
        },
      ],
    };

    this.feeValueByMonthChart.setOption(this.feeValueByMonthChartOptions);
  };

  getTopPortfolioFeesByLimit = () => {
    this.isLoadingPortfolioFees = true;
    this.feesRepo
      .getPortfolioFeesByLimit(
        this.portfolioFeeDate,
        this.feesByPortfolioLimit,
        true,
        this.selectedCurrency,
        this.selectedFeeCalculationTypePortfolioFees,
        this.sortTopBottomPortfolioFeesByNav
      )
      .then((res) => {
        this.topPortfolioFees = res.data as Array<any>;
        this.getTopPortfolioFeeGraph();
        this.topPortfolioFeesGridOptions.data = this.topPortfolioFees;
      })
      .catch((err) => {
        this.notifyjs("Failed to get top portfolio fees " + err.data);
      })
      .finally(() => {
        this.isLoadingPortfolioFees = false;
      });
  };

  getBottomPortfolioFeesByLimit = () => {
    this.isLoadingPortfolioFees = true;
    this.feesRepo
      .getPortfolioFeesByLimit(
        this.portfolioFeeDate,
        this.feesByPortfolioLimit,
        false,
        this.selectedCurrency,
        this.selectedFeeCalculationTypePortfolioFees,
        this.sortTopBottomPortfolioFeesByNav
      )
      .then((res) => {
        this.bottomPortfolioFees = res.data as Array<any>;
        this.bottomPortfolioFeesGridOptions.data = this.bottomPortfolioFees;
        this.getBottomPortfolioFeeGraph();
      })
      .catch((err) => {
        this.notifyjs("Failed to get bottom portfolio fees " + err.data);
      })
      .finally(() => {
        this.isLoadingPortfolioFees = false;
      });
  };

  getTopPortfolioFeeGraph = () => {
    let accountNumbers = this.topPortfolioFees.map(
      (portfolio) => portfolio.accountNumber
    );
    let feeValues;

    if (this.sortTopBottomClientFeesByNav) {
      feeValues = this.topPortfolioFees.map((portfolio) =>
        portfolio.marketValue.toFixed(2)
      );
    } else {
      feeValues = this.topPortfolioFees.map((portfolio) =>
        portfolio.feeValue.toFixed(2)
      );
    }

    this.topPortfolioFeeChartOptions = {
      title: {
        text: `Top ${accountNumbers.length} Portfolio ${
          this.sortTopBottomPortfolioFeesByNav ? "NAVs" : "Fees"
        }`,
        textStyle: {
          fontFamily: "Seravek",
        },
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow",
        },
        formatter: (params) => {
          let feeParam = this.topPortfolioFees.filter(
            (feeParam) => feeParam.accountNumber == params[0].name
          )[0];
          return `Client : ${feeParam.clientName} <br>
                    Portfolio : ${feeParam.accountNumber} <br>
                    Fee Type : ${feeParam.feeTypeName} <br>
                    Fee Value : ${feeParam.feeValue.toLocaleString("en-EN", {
                      style: "currency",
                      currency: this.selectedCurrency,
                    })} <br>
                    NAV : ${feeParam.marketValue.toLocaleString("en-EN", {
                      style: "currency",
                      currency: this.selectedCurrency,
                    })} `;
        },
      },

      grid: {
        left: "3%",
        right: "4%",
        bottom: "3%",
        containLabel: true,
      },
      toolbox: {
        feature: {
          saveAsImage: {
            title: "Save as Image",
          },
          dataZoom: {
            yAxisIndex: "none",
            title: {
              zoom: "Zoom In",
              back: "Back",
            },
          },
          restore: {
            title: "Restore",
          },
        },
      },
      xAxis: {
        type: "category",
        boundaryGap: true,
        data: accountNumbers,
        barGap: 0,
        axisLabel: {
          rotate: 45,
        },
      },
      yAxis: [
        {
          type: "value",
          name: `${this.sortTopBottomPortfolioFeesByNav ? "NAVs" : "Fees"} `,

          axisLabel: {
            formatter: (params) => {
              return params > 0
                ? `${this.selectedCurrency} ${this.normaliseNumbers(params)}`
                : "";
            },
          },
        },
      ],
      series: [
        {
          type: "bar",
          name: "Fee Value",
          data: feeValues,
        },
      ],
    };

    this.topPortfolioFeeChart.setOption(this.topPortfolioFeeChartOptions);
  };

  getBottomPortfolioFeeGraph = () => {
    let accountNumbers = this.bottomPortfolioFees
      .map((portfolio) => portfolio.accountNumber)
      .reverse();

    let feeValues;
    if (this.sortTopBottomClientFeesByNav) {
      feeValues = this.bottomPortfolioFees
        .map((portfolio) => portfolio.marketValue.toFixed(2))
        .reverse();
    } else {
      feeValues = this.bottomPortfolioFees
        .map((portfolio) => portfolio.feeValue.toFixed(2))
        .reverse();
    }
    this.bottomPortfolioFeeChartOptions = {
      title: {
        text: `Bottom ${accountNumbers.length} Portfolio ${
          this.sortTopBottomPortfolioFeesByNav ? "NAVs" : "Fees"
        }`,
        textStyle: {
          fontFamily: "Seravek",
        },
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow",
        },
        formatter: (params) => {
          let feeParam = this.bottomPortfolioFees.filter(
            (feeParam) => feeParam.accountNumber == params[0].name
          )[0];
          return `Client : ${feeParam.clientName} <br>
                    Portfolio : ${feeParam.accountNumber} <br>
                    Fee Type : ${feeParam.feeTypeName} <br>
                    Fee Value : ${feeParam.feeValue.toLocaleString("en-EN", {
                      style: "currency",
                      currency: this.selectedCurrency,
                    })} <br>
                    NAV : ${feeParam.marketValue.toLocaleString("en-EN", {
                      style: "currency",
                      currency: this.selectedCurrency,
                    })} `;
        },
      },

      grid: {
        left: "3%",
        right: "4%",
        bottom: "3%",
        containLabel: true,
      },
      toolbox: {
        feature: {
          saveAsImage: {
            title: "Save as Image",
          },
          dataZoom: {
            yAxisIndex: "none",
            title: {
              zoom: "Zoom In",
              back: "Back",
            },
          },
          restore: {
            title: "Restore",
          },
        },
      },
      xAxis: {
        type: "category",
        boundaryGap: true,
        data: accountNumbers,
        barGap: 0,
        axisLabel: {
          rotate: 45,
        },
      },
      yAxis: [
        {
          type: "value",
          name: `${this.sortTopBottomPortfolioFeesByNav ? "NAVs" : "Fees"} `,
          axisLabel: {
            formatter: (params) => {
              return params > 0
                ? `${this.selectedCurrency} ${this.normaliseNumbers(params)}`
                : "";
            },
          },
        },
      ],
      series: [
        {
          type: "bar",
          name: "Fee Value",
          data: feeValues,
        },
      ],
    };

    this.bottomPortfolioFeeChart.setOption(this.bottomPortfolioFeeChartOptions);
  };

  updatePortfolioFees = () => {
    this.getTopPortfolioFeesByLimit();
    this.getBottomPortfolioFeesByLimit();
  };

  exportPortfolioFeesToCSV = ($event: angular.IAngularEvent) => {
    $event.stopPropagation();
    exportToCSV(this.topPortfolioFees, "Top Portfolio Fees", true);
    exportToCSV(this.bottomPortfolioFees, "Bottom Portfolio Fees", true);
  };

  updateClientFees = () => {
    this.getTopClientFeesByLimit();
    this.getBottomClientFeesByLimit();
  };

  getTopClientFeesByLimit = () => {
    this.isLoadingClientFees = true;
    this.feesRepo
      .getClientFeesByLimit(
        this.clientFeeDate,
        this.feesByClientLimit,
        true,
        this.selectedCurrency,
        this.selectedFeeCalculationTypeClientFees,
        this.sortTopBottomClientFeesByNav
      )
      .then((res) => {
        this.topClientFees = res.data as Array<any>;
        this.getTopClientFeeGraph();
        this.topClientFeesGridOptions.data = this.topClientFees;
      })
      .catch((err) => {
        this.notifyjs("Failed to get top client fees " + err.data);
      })
      .finally(() => {
        this.isLoadingClientFees = false;
      });
  };

  getTopClientFeeGraph = () => {
    let clientNames = this.topClientFees.map((client) => client.clientName);
    let feeValues;
    if (this.sortTopBottomClientFeesByNav) {
      feeValues = this.topClientFees.map((client) =>
        client.marketValue.toFixed(2)
      );
    } else {
      feeValues = this.topClientFees.map((client) =>
        client.feeValue.toFixed(2)
      );
    }

    this.topClientFeeChartOptions = {
      title: {
        text: `Top ${clientNames.length} Client ${
          this.sortTopBottomClientFeesByNav ? "NAVs" : "Fees"
        }`,
        textStyle: {
          fontFamily: "Seravek",
        },
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow",
        },
        formatter: (params) => {
          let feeParam = this.topClientFees.filter(
            (feeParam) => feeParam.clientName == params[0].name
          )[0];
          return `Client : ${feeParam.clientName} <br>
                    Client Number : ${feeParam.clientNumber} <br>
                    Fee Value : ${feeParam.feeValue.toLocaleString("en-EN", {
                      style: "currency",
                      currency: this.selectedCurrency,
                    })} <br>
                    NAV : ${feeParam.marketValue.toLocaleString("en-EN", {
                      style: "currency",
                      currency: this.selectedCurrency,
                    })} `;
        },
      },

      grid: {
        left: "3%",
        right: "4%",
        bottom: "3%",
        containLabel: true,
      },
      toolbox: {
        feature: {
          saveAsImage: {
            title: "Save as Image",
          },
          dataZoom: {
            yAxisIndex: "none",
            title: {
              zoom: "Zoom In",
              back: "Back",
            },
          },
          restore: {
            title: "Restore",
          },
        },
      },
      xAxis: {
        type: "category",
        boundaryGap: true,
        data: clientNames,
        barGap: 0,
        axisLabel: {
          rotate: 45,
        },
      },
      yAxis: [
        {
          type: "value",
          name: `${this.sortTopBottomClientFeesByNav ? "NAVs" : "Fees"} `,

          axisLabel: {
            formatter: (params) => {
              return params > 0
                ? `${this.selectedCurrency} ${this.normaliseNumbers(params)}`
                : "";
            },
          },
        },
      ],
      series: [
        {
          type: "bar",
          name: "Fee Value",
          data: feeValues,
        },
      ],
    };

    this.topClientFeeChart.setOption(this.topClientFeeChartOptions);
  };

  getBottomClientFeesByLimit = () => {
    this.isLoadingClientFees = true;
    this.feesRepo
      .getClientFeesByLimit(
        this.clientFeeDate,
        this.feesByClientLimit,
        false,
        this.selectedCurrency,
        this.selectedFeeCalculationTypeClientFees,
        this.sortTopBottomClientFeesByNav
      )
      .then((res) => {
        this.bottomClientFees = res.data as Array<any>;
        this.getBottomClientFeeGraph();
        this.bottomClientFeesGridOptions.data = this.bottomClientFees;
      })
      .catch((err) => {
        this.notifyjs("Failed to get bottom client fees " + err.data);
      })
      .finally(() => {
        this.isLoadingClientFees = false;
      });
  };

  getBottomClientFeeGraph = () => {
    let clientNames = this.bottomClientFees.map((client) => client.clientName);
    let feeValues;
    if (this.sortTopBottomClientFeesByNav) {
      feeValues = this.bottomClientFees.map((client) =>
        client.marketValue.toFixed(2)
      );
    } else {
      feeValues = this.bottomClientFees.map((client) =>
        client.feeValue.toFixed(2)
      );
    }

    this.bottomClientFeeChartOptions = {
      title: {
        text: `Bottom ${clientNames.length} Client ${
          this.sortTopBottomClientFeesByNav ? "NAVs" : "Fees"
        }`,
        textStyle: {
          fontFamily: "Seravek",
        },
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow",
        },
        formatter: (params) => {
          let feeParam = this.bottomClientFees.filter(
            (feeParam) => feeParam.clientName == params[0].name
          )[0];
          return `Client : ${feeParam.clientName} <br>
                    Client Number : ${feeParam.clientNumber} <br>
                    Fee Value : ${feeParam.feeValue.toLocaleString("en-EN", {
                      style: "currency",
                      currency: this.selectedCurrency,
                    })} <br>
                    NAV : ${feeParam.marketValue.toLocaleString("en-EN", {
                      style: "currency",
                      currency: this.selectedCurrency,
                    })} `;
        },
      },

      grid: {
        left: "3%",
        right: "4%",
        bottom: "3%",
        containLabel: true,
      },
      toolbox: {
        feature: {
          saveAsImage: {
            title: "Save as Image",
          },
          dataZoom: {
            yAxisIndex: "none",
            title: {
              zoom: "Zoom In",
              back: "Back",
            },
          },
          restore: {
            title: "Restore",
          },
        },
      },
      xAxis: {
        type: "category",
        boundaryGap: true,
        data: clientNames,
        barGap: 0,
        axisLabel: {
          rotate: 45,
        },
      },
      yAxis: [
        {
          type: "value",
          name: `${this.sortTopBottomClientFeesByNav ? "NAVs" : "Fees"} `,

          axisLabel: {
            formatter: (params) => {
              return params > 0
                ? `${this.selectedCurrency} ${this.normaliseNumbers(params)}`
                : "";
            },
          },
        },
      ],
      series: [
        {
          type: "bar",
          name: "Fee Value",
          data: feeValues,
        },
      ],
    };

    this.bottomClientFeeChart.setOption(this.bottomClientFeeChartOptions);
  };

  exportClientFeesToCSV = ($event: angular.IAngularEvent) => {
    $event.stopPropagation();
    let topClientFees = _.flatten(
      _.map(this.topClientFees, (clientFee) => {
        return _.flatten(
          _.map(clientFee.portfolios, (portfolioFee) => {
            return {
              clientNumber: clientFee.clientNumber,
              clientName: clientFee.clientName,
              currency: this.selectedCurrency,
              totalFeeValue: clientFee.feeValue,
              totalFeeExclusion: clientFee.feeExclusionValue,
              totalMarketValue: clientFee.marketValue,
              accountNumber: portfolioFee.accountNumber.toString(),
              feeType: portfolioFee.feeTypeName,
              feeValue: portfolioFee.feeValue,
              feeExclusion: portfolioFee.feeExclusionValue,
              marketValue: portfolioFee.marketValue,
            };
          })
        );
      })
    );

    let bottomClientFees = _.flatten(
      _.map(this.bottomClientFees, (clientFee) => {
        return _.flatten(
          _.map(clientFee.portfolios, (portfolioFee) => {
            return {
              clientNumber: clientFee.clientNumber,
              clientName: clientFee.clientName,
              currency: this.selectedCurrency,
              totalFeeValue: clientFee.feeValue,
              totalFeeExclusion: clientFee.feeExclusionValue,
              totalMarketValue: clientFee.marketValue,
              accountNumber: portfolioFee.accountNumber.toString(),
              feeType: portfolioFee.feeTypeName,
              feeValue: portfolioFee.feeValue,
              feeExclusion: portfolioFee.feeExclusionValue,
              marketValue: portfolioFee.marketValue,
            };
          })
        );
      })
    );

    // exportToCSV(flattenedArray, 'ClientBalances', true);
    exportToCSV(topClientFees, "Top Client Fees", true);
    exportToCSV(bottomClientFees, "Bottom Client Fees", true);
  };

  updateFeeTypeFees = () => {
    this.getTopFeeTypesByLimit();
    // this.getBottomFeeTypesByLimit();
  };

  getTopFeeTypesByLimit = () => {
    this.isLoadingFeeTypesFees = true;
    this.feesRepo
      .getFeeTypesFeesByLimit(
        this.feeTypesFeeDate,
        this.feesByFeeTypesLimit,
        true,
        this.selectedCurrency,
        this.selectedFeeCalculationTypeFeeTypesFees,
        this.sortTopBottomFeeTypesFeesByNav
      )
      .then((res) => {
        this.topFeeTypesFees = res.data as Array<any>;
        this.getTopFeeTypesFeeGraph();
        this.topFeeTypesFeesGridOptions.data = this.topFeeTypesFees;
      })
      .catch((err) => {
        this.notifyjs("Failed to get top client fees " + err.data);
      })
      .finally(() => {
        this.isLoadingFeeTypesFees = false;
      });
  };

  getTopFeeTypesFeeGraph = () => {
    let feeTypeNames = this.topFeeTypesFees.map(
      (feeType) => feeType.feeTypeName
    );
    let feeValues;
    if (this.sortTopBottomFeeTypesFeesByNav) {
      feeValues = this.topFeeTypesFees.map((feeType) =>
        feeType.marketValue.toFixed(2)
      );
    } else {
      feeValues = this.topFeeTypesFees.map((feeType) =>
        feeType.feeValue.toFixed(2)
      );
    }

    this.topFeeTypesFeeChartOptions = {
      title: {
        text: `Top ${feeTypeNames.length} Fee Types ${
          this.sortTopBottomFeeTypesFeesByNav ? "NAVs" : "Fees"
        }`,
        textStyle: {
          fontFamily: "Seravek",
        },
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow",
        },
        formatter: (params) => {
          let feeParam = this.topFeeTypesFees.filter(
            (feeParam) => feeParam.feeTypeName == params[0].name
          )[0];
          return `  Fee Type : ${feeParam.feeTypeName} <br>
                    Fee Value : ${feeParam.feeValue.toLocaleString("en-EN", {
                      style: "currency",
                      currency: this.selectedCurrency,
                    })} <br>
                    NAV : ${feeParam.marketValue.toLocaleString("en-EN", {
                      style: "currency",
                      currency: this.selectedCurrency,
                    })} `;
        },
      },

      grid: {
        left: "3%",
        right: "4%",
        bottom: "3%",
        containLabel: true,
      },
      toolbox: {
        feature: {
          saveAsImage: {
            title: "Save as Image",
          },
          dataZoom: {
            yAxisIndex: "none",
            title: {
              zoom: "Zoom In",
              back: "Back",
            },
          },
          restore: {
            title: "Restore",
          },
        },
      },
      xAxis: {
        type: "category",
        boundaryGap: true,
        data: feeTypeNames,
        barGap: 0,
        axisLabel: {
          rotate: 45,
        },
      },
      yAxis: [
        {
          type: "value",
          name: `${this.sortTopBottomFeeTypesFeesByNav ? "NAVs" : "Fees"} `,

          axisLabel: {
            formatter: (params) => {
              return params > 0
                ? `${this.selectedCurrency} ${this.normaliseNumbers(params)}`
                : "";
            },
          },
        },
      ],
      series: [
        {
          type: "bar",
          name: "Fee Value",
          data: feeValues,
        },
      ],
    };

    this.topFeeTypesFeeChart.setOption(this.topFeeTypesFeeChartOptions);
  };

  exportFeeTypesFeesToCSV = ($event: angular.IAngularEvent) => {
    $event.stopPropagation();
    exportToCSV(this.topFeeTypesFees, "Fee Types", true);
  };

  getAuditExcel = () => {
    this.feesRepo
      .getAuditExcel(this.fromDate, this.toDate, FeeCalculationType.MCB)
      .then((res) => {
        let mcbExcel = res.data as any;
        this.$window.open(mcbExcel.url, "_blank");
      })
      .catch((err) => {
        this.notifyjs(
          "Failed to generate audit excel for MCB portfolios " + err.data
        );
      });

    this.feesRepo
      .getAuditExcel(this.fromDate, this.toDate, FeeCalculationType.EDR)
      .then((res) => {
        let edrExcel = res.data as any;
        this.$window.open(edrExcel.url, "_blank");
      })
      .catch((err) => {
        this.notifyjs(
          "Failed to generate audit excel for EDR portfolios " + err.data
        );
      });
  };
}

export enum FeeCalculationType {
  EDR = 0,
  MCB = 1,
  COMBINED = 2,
}

export const fees: angular.IComponentOptions = {
  template: require("./fees.html"),
  controller: FeesController,
};



// WEBPACK FOOTER //
// ./src/app/fees/fees.ts